import { useI18n } from '../../i18n'
import type { PayChannel } from '../../types'

interface PaymentMethodSelectorProps {
  value: PayChannel
  onChange: (channel: PayChannel) => void
}

export function PaymentMethodSelector({ value, onChange }: PaymentMethodSelectorProps) {
  const { t } = useI18n()

  const methods: { channel: PayChannel; labelZh: string; labelEn: string; icon: string; color: string }[] = [
    { channel: 'ALIPAY', labelZh: '支付宝', labelEn: 'Alipay', icon: '支', color: 'bg-blue-50 border-blue-200 text-blue-600' },
    { channel: 'WECHAT', labelZh: '微信支付', labelEn: 'WeChat Pay', icon: '微', color: 'bg-green-50 border-green-200 text-green-600' },
  ]

  return (
    <div className="space-y-2">
      <p className="text-xs text-gray-400">{t('选择支付方式', 'Select Payment Method')}</p>
      <div className="flex gap-3">
        {methods.map((m) => (
          <button
            key={m.channel}
            onClick={() => onChange(m.channel)}
            className={`flex-1 flex items-center gap-3 p-3 rounded-xl border-2 transition-all ${
              value === m.channel
                ? `${m.color} border-current`
                : 'border-black/[0.04] hover:border-orange-100'
            }`}
          >
            <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold ${
              value === m.channel ? m.color : 'bg-gray-50 text-gray-400'
            }`}>
              {m.icon}
            </span>
            <span className="text-sm font-medium text-[#1a1a1a]">
              {t(m.labelZh, m.labelEn)}
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}
